import { render, staticRenderFns } from "./materials-scanner.vue?vue&type=template&id=60537be4"
import script from "./materials-scanner.vue?vue&type=script&lang=js"
export * from "./materials-scanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports